import React from "react";
import { cn } from "../lib/helpers";
import FigureG from "./figure-g";
import Container from "./container";

import * as styles from "../styles/components/fc-images.module.css";

interface Image {
  asset?: {
    _id?: string;
  };
  alt?: string;
  _rawCaption?: any[];
}

interface ImageItem {
  _key?: string;
  image?: Image;
  sizeLarge?: boolean;
}

interface ImagesProps {
  images?: ImageItem[];
}

const Images: React.FC<ImagesProps> = ({ images }) => {
  if (!images || images.length === 0) {
    return null;
  }

  return (
    <div className={styles.root}>
      <Container>
        {images.map(({ _key, image, sizeLarge }) => (
          <div className={cn(styles.item, !sizeLarge && styles.small)} key={_key}>
            <FigureG node={image} />
          </div>
        ))}
      </Container>
    </div>
  );
};

export default Images;
